import type { SupportedLanguage } from "@amtana/i18n";

// What a credit buys, as the Terms say it (D1153, decided by Sergio; issue #164). The landing page
// and the pricing page read these sentences, so the two can never disagree. If the meaning of a
// credit changes, it changes here, in the Terms and in the charge.

type InEachLanguage = Readonly<Record<SupportedLanguage, string>>;

export const CREDIT_MEANING: InEachLanguage = {
  en: "One credit reads one public Instagram profile, whether or not it shows a contact.",
  es: "Un crédito lee un perfil público de Instagram, muestre o no un contacto.",
};

export const CREDIT_LIMITS: InEachLanguage = {
  en: "Private accounts are not read, and not every public profile shows a contact.",
  es: "Las cuentas privadas no se leen, y no todos los perfiles públicos muestran un contacto.",
};

export const CREDIT_READ_AGAIN: InEachLanguage = {
  en: "Reading a profile again in another analysis costs another credit.",
  es: "Volver a leer un perfil en otro análisis cuesta otro crédito.",
};
